import React, { PropsWithChildren } from 'react';

import { useStoreContext } from 'features/store';

import { LocationEmptyState } from 'components/location-empty-state';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { t } from 'state/intl/translations';

const MenuEmptyState = () => {
  return <LocationEmptyState title={t('emptyMenuHeading')} message={t('emptyMenuMessage')} />;
};

const MenuEmptyStateWrapper = ({ children }: PropsWithChildren) => {
  const { noStoreSelected, isSelectingStore } = useStoreContext();

  if (isSelectingStore) {
    return <LoyaltyLoader />;
  }

  if (noStoreSelected) {
    return <MenuEmptyState />;
  }

  return children;
};

const withMenuEmptyState = (Component: React.ComponentType<React.PropsWithChildren>) => (
  props: any
) => {
  return (
    <MenuEmptyStateWrapper>
      <Component {...props} />
    </MenuEmptyStateWrapper>
  );
};

export default withMenuEmptyState;
